/**
 * Category Bar Component
 *
 * Displays one of the three ATS scoring categories as a horizontal bar:
 *   [Icon] Label  ████████░░  8/10  (30%)
 *
 * Uses a 10-segment progress bar matching the ATSScoreReportV2 pattern.
 */

import React from 'react';
import { cx, getSubScoreVariant } from '../utils/score-helpers';
import type { CategoryBarProps } from '../types';

const TOTAL_SEGMENTS = 10;

export const CategoryBar: React.FC<CategoryBarProps> = ({
  label,
  score,
  weight,
  icon,
}) => {
  const variant = getSubScoreVariant(score);
  const filledSegments = Math.round(score);

  return (
    <div className="ats-report-category-bar">
      <div className="ats-report-category-bar__header">
        <span className="ats-report-category-bar__icon">{icon}</span>
        <span className="ats-report-category-bar__label">{label}</span>
        <span className={cx(
          'ats-report-category-bar__score',
          `ats-report-category-bar__score--${variant}`,
        )}>
          {score}/10
        </span>
        <span className="ats-report-category-bar__weight">({weight}%)</span>
      </div>

      <div className="ats-report-segmented-bar">
        {Array.from({ length: TOTAL_SEGMENTS }, (_, i) => (
          <div
            key={i}
            className={cx(
              'ats-report-segmented-bar__segment',
              i < filledSegments
                ? `ats-report-segmented-bar__segment--filled ats-report-segmented-bar__segment--${variant}`
                : 'ats-report-segmented-bar__segment--empty',
            )}
          />
        ))}
      </div>
    </div>
  );
};

CategoryBar.displayName = 'CategoryBar';

export default CategoryBar;
